import { SEARCH_OPEN, SEARCH_CLOSE, SEARCH_CATEGORY_SELECT } from '@/store/types'
const state = {
  show: false,
  active: undefined
}

const getters = {}

const mutations = {
  [SEARCH_OPEN](state) {
    state.show = true
  },
  [SEARCH_CLOSE](state) {
    state.show = false
  },
  [SEARCH_CATEGORY_SELECT] (state, data) {
    state.active = data
  }
}

const actions = {
  async dataSearchOpen({ commit }, data) {
    commit(SEARCH_OPEN)
    if (data) {
      commit(SEARCH_CATEGORY_SELECT, data)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
